const AlertMessage = (props) => {

  let errorMessage = "";

  if (props.alertMessage.hasOwnProperty("message") &&
    props.alertMessage.message.length > 0) {
    errorMessage = props.alertMessage.message;
  } else {
    errorMessage = "Please contact support. Thank you!"
  }

  return (
    <div className="error-container">
      {/* Error Icon - Using a circular design */}
      <div className="error-icon-wrapper">
        <div className="error-icon-circle">
          <span className="error-icon-x">✕</span>
        </div>
      </div>

      {/* Main Content */}
      <h1 className="error-title-main">Oops!</h1>
      <h2 className="error-subtitle">Something Went Wrong</h2>
      <p className="error-message-text">{errorMessage}</p>

      {/* Support Info */}
      <div className="error-footer">
        <p>Need help? Contact our support team</p>
      </div>
    </div>
  )

}

export default AlertMessage;